import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import "./index.css"
import App from "./Components/App"
import reportWebVitals from "./reportWebVitals"
import { ToastContainer, Zoom } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import xThin from "./images/ic-x-gray.svg"

const container = document.getElementById("root")
if (!container) {
  throw new Error("Root container #root not found")
}

createRoot(container).render(
  <BrowserRouter>
    <App />
    <ToastContainer
      position="top-center"
      className="global--toast"
      hideProgressBar={true}
      transition={Zoom}
      closeButton={({ closeToast }: { closeToast: (e: React.MouseEvent<HTMLButtonElement>) => void }) => (
        <button onClick={closeToast} className="flex-shrink-0 self-start">
          <img src={xThin} alt="close" />
        </button>
      )}
    />
  </BrowserRouter>
)

reportWebVitals()
